import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Box, Text } from '@cad-arc';
import { BaseSelect } from '../../../forms/inputs/base-select';
import { CautionPill } from '../../../cautions/components/caution-pill';
import { GenericObject } from '../../../common/types';
import { GeoCautionDto } from '@mark43/rms-api';
import { alphabeticalStringSort } from '../../../common/sorting/sorts';
import { CommonSize } from '../../../common/helpers/utils';

type SubPremiseCaution = {
    categoryHeader: string;
    cautionLevel: number;
    cautions: (GeoCautionDto & { cautionLevel: number })[];
};

type SubPremiseCautionBlockProps = {
    isCautionsGroupedByCategory: boolean;
    subPremiseCautions: GenericObject<SubPremiseCaution[]>;
    size?: CommonSize;
};

export function SubPremiseCautionBlock({
    isCautionsGroupedByCategory,
    subPremiseCautions,
    size,
}: SubPremiseCautionBlockProps): React.ReactElement | null {
    const [subPremise, setSubPremise] = useState('');

    const subPremiseOptions = useMemo(() => {
        return Object.keys(subPremiseCautions)
            .map((subPremise) => {
                return {
                    label: subPremise,
                    value: subPremise,
                };
            })
            .sort((a, b) => alphabeticalStringSort(a.label, b.label));
    }, [subPremiseCautions]);

    useEffect(() => {
        setSubPremise('');
    }, [subPremiseCautions]);

    if (isEmpty(subPremiseCautions)) {
        return null;
    }
    const cautionStruct = subPremiseCautions[subPremise];

    return (
        <Box display="flex" flexDirection="column" marginTop={isCautionsGroupedByCategory ? 2 : 0}>
            <Box marginBottom={1}>
                <Text fontSize={size} fontWeight="bold">
                    Sub-premise
                </Text>
            </Box>
            <Box width="120px">
                <BaseSelect
                    value={subPremise}
                    options={subPremiseOptions}
                    isClearable={false}
                    onChange={(e) => {
                        setSubPremise(e.target.value);
                    }}
                />
            </Box>
            <Box marginTop={subPremise ? 2 : 0}>
                {cautionStruct?.length > 0 &&
                    cautionStruct.map(({ cautions, categoryHeader }) => (
                        <Box key={categoryHeader}>
                            <Text fontSize={size}>{categoryHeader}</Text>
                            {cautions.map((caution) => (
                                <CautionPill
                                    key={caution.id}
                                    caution={caution}
                                    size={size == 'lg' ? 'md' : 'sm'}
                                />
                            ))}
                        </Box>
                    ))}
            </Box>
        </Box>
    );
}
